import React from 'react'
import HomeBanner from '../Components/HomeBanner'
import frame from "../assets/images/frame1.png"
import our from "../assets/images/our.jpg"
import ExtraActivityCard from '../Components/common/ExtraActivityCard'
import arts from "../assets/images/arts.png"
import sports from "../assets/images/sports.png"
import clubs from "../assets/images/club.png"
import leadership from "../assets/images/leadership.png"
import religious from "../assets/images/religious.png"
import volunteering from "../assets/images/volunteering.png"
import departmentIcon from "../assets/images/department 1.png"
import newslatter from "../assets/images/newslatter.png"
import FAQ from '../Components/FAQ'
import Calendar from '../Components/Calendar'
import Newsletter from '../Components/Newsletter'
import { useNavigate } from "react-router-dom";

const Home = (props) => {
    console.log('props: ', props);
    const navigate = useNavigate();
    const activities = [
        {
            icon: arts,
            title: "Arts",
            description: "Our students are given opportunities to express themselves through visual arts, drama, dance, and music. We host regular talent shows, art exhibitions, and cultural events to celebrate their creativity."

        },
        {
            icon: sports,
            title: "Sports",
            description: "Sports are an essential part of student life, promoting health, discipline, and teamwork. We offer competitive and recreational sports, with regular training, tournaments, and inter-school competitions."

        }, {
            icon: clubs,
            title: "Clubs",
            description: "Our clubs are student-driven, supported by mentors, and provide platforms for learners to pursue their passions and sharpen their skills in various fields."

        }, {
            icon: leadership,
            title: "Leadership",
            description: "We instill values of leadership, empathy, and service through student councils, mentorship programs, and community outreach initiatives."

        }, {
            icon: religious,
            title: "Religious",
            description: "The Religious Club offers a space for students to grow in faith, share spiritual experiences, and serve the community with love and compassion."

        }, {
            icon: volunteering,
            title: "Volunteering",
            description: "The Volunteering Club empowers students to make a positive impact by engaging in community service and promoting a culture of giving and support."

        }
    ]

    const department = {
        icon: departmentIcon,
        title: "Departments",
        description: "School departments collaborate to elevate our students to new levels of achievement. Each department is comprised of educators who specialize in a particular field, thereby strengthening the department, which is reflected in the overall performance of the school."
    }

    return (
        <>
            <HomeBanner data={props.data} />
            {/*About  Section with background image */}
            <div className="relative bg-gray-100 py-[80px] " >
                {/* Section with background image */}

                <div className="container mx-auto px-4 md:px-10 lg:px-24 text-left flex justify-between flex-col lg:flex-row  gap-10">
                    {/* Text content */}
                    <div className="lg:w-[500px] ">
                        <h2 className="text-3xl font-semibold mb-4">
                            About <span className="text-primary_main">Our School</span>
                        </h2>
                        <p className="mb-4 text-base">
                            {props.data ? props.data.about : ""}
                        </p>
                    </div>

                    {/* Image on the right */}
                    <div
                        className="
                            w-full  lg:w-[36rem] 
                            flex items-center justify-center 
                            h-[250px] sm:h-[320px] md:h-[380px] lg:h-[442px]
                            
                        "
                        style={{
                            backgroundImage: `url(${frame})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    >
                        <img
                            src={props.data?.about_image || ""}
                            alt="About"
                            className="
                            w-[80%] sm:w-[85%] md:w-[90%] lg:w-[500px] 
                            h-[180px] sm:h-[250px] md:h-[320px] lg:h-[373px]
                            object-cover shadow-lg rounded-lg
                            "
                        />
                    </div>

                </div>

            </div >
            {/* Extracurricular Section */}
            <div div className="py-12 bg-purple-50" >
                <div className="container mx-auto px-4 md:px-10 text-center">
                    <h2 className="text-3xl font-semibold mb-8">Extracurricular  <span className="text-primary_main">Activities</span></h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
                        {activities && activities.map((activity, index) => {
                            return (
                                <ExtraActivityCard
                                    key={index}
                                    icon={activity.icon}
                                    title={activity.title}
                                    description={activity.description}
                                />
                            )
                        })}
                    </div>
                </div>
            </div >

            <div className="mt-8 bg-[#FFF6F4] rounded-lg container mx-auto flex flex-col md:flex-row justify-between items-center px-6 md:px-8 py-6 md:h-[190px]">
                <div className="flex flex-col sm:flex-row items-center text-center sm:text-left">
                    <img
                        src={department.icon}
                        alt="department"
                        className="h-20 w-20 sm:h-28 sm:w-28"
                    />
                    <div className="flex flex-col items-center sm:items-start sm:ml-5 mt-3 sm:mt-0">
                        <p className="font-bold text-2xl sm:text-4xl mb-1">{department.title}</p>
                        <p className="text-sm sm:text-base max-w-[600px]">
                            {department.description}
                        </p>
                    </div>
                </div>

                <button
                    className="bg-secondary_main rounded-lg w-28 sm:w-32 h-12 font-bold text-white mt-4 md:mt-0"
                    onClick={() =>
                        navigate(`/departments`, {
                            state: {
                                title: department.title,
                                description: department.description
                            },
                        })
                    }
                >
                    View More
                </button>
            </div>

            <div className='py-12'>
                <Calendar />
            </div>
            {/* NewsLetter Section  */}
            {/* <Newsletter/>
            <FAQ/> */}

        </>
    )
}

export default Home